module.exports = __webpack_public_path__ + "static/media/findMentor.e9fe6e42.svg";